import { render } from "./NaviItemLinkForSpOnGeneral.vue?vue&type=template&id=6c0d76c1&scoped=true&ts=true"
import script from "./NaviItemLinkForSpOnGeneral.vue?vue&type=script&lang=ts"
export * from "./NaviItemLinkForSpOnGeneral.vue?vue&type=script&lang=ts"

import "./NaviItemLinkForSpOnGeneral.vue?vue&type=style&index=0&id=6c0d76c1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0d76c1"]])

export default __exports__